'use strict';

const JsBarcode = require('jsbarcode');
const { alertMessage } = require('../common/common');
var billingHelpers = require('../checkout/billing');
const AddressAutocomplete = require('../addressAutocomplete/addressAutocomplete');

const SELECTORS = {
  fideltyCardShow: '.js-fideltycard-show',
  fideltyCardReset: '.js-fideltycard-reset',
  codeCopy: '.js-code-copy',
  wrapFideltyCard: '.cc-wrap-fideltycard',
  buttonShowCouponPage: '.js-toggle-coupon-page',
  wrapCouponCodePage: '.js-couponcode-page',
  wrapCouponInfoPage: '.js-coupon-info-page',
  barCodePageBtn: '.js-copy-bar-code',
  jsCodeOnpage: '.js-bcode',
  fideltyCardShowBarcde: '.js-fideltycard-show-barCode',
  infoCardShowBarcde: '.js-info-barCode',
  couponCardOnPage: '.js-coupon-card',
  fideltyLabelShow: '.js-show-code',
  fideltyLabelHide: '.js-hide-code'
};

const CLASSES = {
  hidden: 'd-none',
  couponSelected: 'js-coupon-selected',
  couponStyleClass: 'cc-coupon-selected'
};

const MESSAGES = {
  copySuccess: 'Code wurde kopiert.'
};

const SHIPPING_CONFIG = {
    postalCodeSelector: '#zipCode',
    citySelector: '#city',
    streetSelector: '#address1',
    countrySelector: '#country',
};

const BILLING_CONFIG = {
    postalCodeSelector: '#zipCode',
    citySelector: '#city',
    streetSelector: '#address1',
    countrySelector: '#billingCountry',
};

const BILLING_REGISTRATION_CONFIG = {
    postalCodeSelector: '#registration-form-postalCode',
    citySelector: '#registration-form-city',
    streetSelector: '#registration-form-address1',
    countrySelector: '#registration-form-country',
};

class FideltyCardManager {
  constructor() {
    this.initEvents();
  }

  initEvents() {
    $(document).ready(() => {

      $(SELECTORS.couponCardOnPage).each((index, element) => {
        this.checkSelectedCouponOnPage(element);
      });

      $(SELECTORS.fideltyCardShow).click((e) => {
        this.handleShowClick(e);
      });

      $(SELECTORS.fideltyCardReset).click((e) => {
        this.handleResetClick(e);
      });

      JsBarcode('.barcode').init();

      $(SELECTORS.buttonShowCouponPage).each((index, element) => {
        $(element).click((element) => {
          this.showCouponCodeOnPage(element.target);
        });
      });

      $(SELECTORS.barCodePageBtn).click((e) => {
        this.copyBarCodePage(e);
      });

      $(SELECTORS.fideltyCardShowBarcde).click((e) => {
        this.showFideltyCardBarcode(e);
      });
      
      billingHelpers.toggleAddress3Field();

      new AddressAutocomplete(SHIPPING_CONFIG).init();
      new AddressAutocomplete(BILLING_CONFIG).init();
      new AddressAutocomplete(BILLING_REGISTRATION_CONFIG).init();
    });
  }

  handleShowClick(event) {
    $(SELECTORS.wrapFideltyCard).toggleClass(CLASSES.hidden);
    $(event.currentTarget).hide();
  }

  handleResetClick(event) {
    const codice = $(SELECTORS.codeCopy).text().trim();
    if (codice !== '') {
      this.copyToClipboard(codice);
    }
    $(SELECTORS.wrapFideltyCard).addClass(CLASSES.hidden);
    $(SELECTORS.fideltyCardShow).show();
  }

  copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(function() {
      alertMessage(MESSAGES.copySuccess, 'cc-alert--success');
    }, function(err) {
      console.error('Error: ', err);
    });
  }

  showCouponCodeOnPage(element) {
    const btn = element;
    const $infoElement = $(btn).closest($(SELECTORS.wrapCouponInfoPage));
    $infoElement.find(SELECTORS.wrapCouponCodePage).toggle();
  }

  copyBarCodePage(e) {
    const bCode = $(e.currentTarget).closest(SELECTORS.wrapCouponInfoPage).find(SELECTORS.jsCodeOnpage).text();
    if (bCode !== '') {
      this.copyToClipboard(bCode);
      alertMessage(MESSAGES.copySuccess, 'cc-alert--success');
    }
  }

  showFideltyCardBarcode(event) {
    $(SELECTORS.infoCardShowBarcde).toggleClass(CLASSES.hidden);
    $(SELECTORS.fideltyLabelShow).toggleClass(CLASSES.hidden);
    $(SELECTORS.fideltyLabelHide).toggleClass(CLASSES.hidden);
  }

  checkSelectedCouponOnPage(element) {
    const coupSel = $(element);

    if (coupSel.hasClass(CLASSES.couponSelected)) {
        const btnToggle = coupSel.find(SELECTORS.buttonShowCouponPage).first();
        this.showCouponCodeOnPage(btnToggle);
        setTimeout(() => {
          coupSel.removeClass(CLASSES.couponStyleClass)
        },5000);
    }
  }
}

// Needs to be defined in a global scope because it is used
// in both the checkout flow and the myAccount area.
$('#coupon-description-modal').on('show.bs.modal', function (evt) {
        document.body.appendChild(document.getElementById('coupon-description-modal'));
        const trigger = evt.relatedTarget;
        if (!trigger) return;

        const encodedHtml = trigger.getAttribute('data-coupon-description') || '';
        let decodedHtml = '';

        try {
            decodedHtml = decodeURIComponent(encodedHtml);
        } catch {
            const safeEncoded = encodedHtml.replace(/%(?![0-9A-Fa-f]{2})/g, '%25');
            try {
                decodedHtml = decodeURIComponent(safeEncoded);
            } catch {
                decodedHtml = encodedHtml;
            }
        }
        
        document.querySelector('.js-coupon-modal .cc-modal__body').innerHTML = decodedHtml;
    });

const fideltyCardManagerInstance = new FideltyCardManager();
